var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Copied To clipboard! You can also access the page "),_c('a',{staticClass:"cool-white-link",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("here")])])])}
var staticRenderFns = []

export { render, staticRenderFns }